<div class="ap-container">
  @if (this.content()) {
    <gstar-extended-editor
      #editor
      [content]="content()"
      [allowEmpty]="true"
      [allowInternalLinks]="true"
      [canEdit]="canEditCountry()"
      [mode]="mode()"
      (dismiss)="cancel()"
      (save)="save($event)">
      <ng-container title-edit>
        <h2>Edit - {{ countryName() }}: {{ title() }}</h2>
      </ng-container>
      <ng-container toolbar-edit>
        <form [formGroup]="reviewDateForm" class="mb-0 review-date-form">
          <gstar-datepicker
            [value]="reviewDateValue()"
            [label]="'shared.lastReviewDate' | translate"
            formControlName="reviewDate" />
        </form>
      </ng-container>
    </gstar-extended-editor>
  }
</div>
